export default __webpack_public_path__ + "static/media/learning.eb0a8100.svg";